import React from 'react';
import { Button, Dropdown } from './';
import { DownOutlined } from '@ant-design/icons';
import { DOCUMENTATION } from '../constants/docLinks';
import { buildDocumentationMenuItems } from './DocumentationMenuItems';

export const DocumentationLinksDropdown = ({ documentationType }) => {
    const { buttonText } = DOCUMENTATION[documentationType] || {};
    const menuItems = buildDocumentationMenuItems(documentationType);

    return (
        <Dropdown menu={{ items: menuItems }} placement="bottomLeft">
            <Button>
                {buttonText} <DownOutlined />
            </Button>
        </Dropdown>
    );
};
